import { create } from 'zustand';
import type { Node, Edge } from '../core/models/scene';

export interface DiffHighlight {
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
  type: 'added' | 'deleted' | 'modified';
}

export interface HistoryPreviewScope {
  diagramId: string;
  requestId: number;
  createdAt: string;
  snapshotBytes: string;
}

interface HistoryPreviewState {
  requestId: number;
  scope: HistoryPreviewScope | null;
  projectionStatus: 'idle' | 'loading' | 'ready' | 'unavailable';
  activeVersion: number | null;
  previewNodes: Node[] | null;
  previewEdges: Edge[] | null;
  diffHighlights: DiffHighlight[];
  begin: () => number;
  setPreview: (version: number, nodes: Node[], edges: Edge[], highlights: DiffHighlight[], scope: HistoryPreviewScope) => void;
  setProjectionStatus: (requestId: number, status: HistoryPreviewState['projectionStatus']) => void;
  clear: () => void;
}

export const useHistoryPreviewStore = create<HistoryPreviewState>((set, get) => ({
  requestId: 0,
  scope: null,
  projectionStatus: 'idle',
  activeVersion: null,
  previewNodes: null,
  previewEdges: null,
  diffHighlights: [],
  begin: () => {
    get().clear();
    return get().requestId;
  },
  setPreview: (version, nodes, edges, highlights, scope) => {
    if (scope.requestId !== get().requestId) return;
    set({ scope, activeVersion: version, previewNodes: nodes, previewEdges: edges, diffHighlights: highlights });
  },
  setProjectionStatus: (requestId, projectionStatus) => {
    if (requestId === get().requestId) set({ projectionStatus });
  },
  clear: () => set((state) => ({
    requestId: state.requestId + 1, scope: null, projectionStatus: 'idle',
    activeVersion: null, previewNodes: null, previewEdges: null, diffHighlights: [],
  })),
}));
